import React from 'react';
import { useMeshGradient } from './hooks/useMeshGradient';
import { OVERBLEED } from './utils/constants';

const MeshGradient = () => {
  const canvasRef = useMeshGradient();

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: `-${OVERBLEED / 2}px`,
        left: `-${OVERBLEED / 2}px`,
        pointerEvents: 'none',
        zIndex: 0,
        opacity: 1,
      }}
    />
  );
};

export default MeshGradient;
